import { useOpstelClient } from "@opstel/contexts/opstelClient/useOpstelClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import {
  BorderTrainsResponse,
  borderTrainsResponseSchema,
} from "@opstel/query/v2/models/borderTrains";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

export function useBorderTrains(shuntingUnitId: string): UseQueryResult<BorderTrainsResponse> {
  const { instanceId } = useCurrentInstanceId();
  const { opstelClient } = useOpstelClient();

  return useQuery({
    queryKey: instances.current(instanceId).shuntingUnit(shuntingUnitId).borderTrains,
    queryFn: () =>
      opstelClient.getBorderTrains({
        instanceId: instanceId ?? "",
        shuntingUnitId,
      }),
    select: (r) => borderTrainsResponseSchema.parse(r),
  });
}
